export default {
    nav1: "首頁管理",
    nav2: "我的商品",
    nav3: "管理子公司/分行",
    nav4: "收貨地址管理",
    nav5: "管理部門",
    nav6: "管理用戶",
    nav7: "公司資料修改",
    nav8: "用戶密碼修改",
    nav9: "報價車",
    nav10: "報價車訂單",
    nav11: "購物車",
    nav12: "訂單狀態",
    nav13: "訂單匯總",
    nav14: "數據分析",
    nav15: "銷售分析",
    nav16: "商品銷售分析",
    nav17: "月結單下載",
    nav18: "我的收藏",
    nav19: "資源中心",
    nav20: "支付狀態",
}